import { useEffect, useContext } from 'react';

import { DocumentTitleContext } from './DocumentTitleContext';

export const useSyncDocumentTitle = (title) => {
  const {
    titleAffix,
    prefix,
    title: ContextTitle,
  } = useContext(DocumentTitleContext);
  useEffect(() => {
    window.document.title = `${titleAffix ? `${titleAffix} - ` : ''}${
      prefix
    } ${title} - ${ContextTitle}`;
  }, [titleAffix, ContextTitle, title]);
};

export default useSyncDocumentTitle;
